import apiClient from './api-client';

// Importa serviços
export * from './auth.service';
export * from './util.service';
export * from './room.service';
export * from './chat.service';

// Exporta a instância do axios para uso avançado
export default apiClient;

